import React from 'react';
import _ from 'lodash';
import {Loader} from '../../../components/Loader/Loader';
import { AutoSizer, Column, SortDirection, Table } from 'react-virtualized';

class VirtualizedTable extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            sortBy: props.sortBy,
            sortDirection: props.sortDirection,
            sortedList: this._sortList({ sortBy: props.sortBy, sortDirection: props.sortDirection })
        };
    }

    _noRowsRenderer = () => {
        return <div />;
    }

    _headerRenderer = ({ dataKey, sortBy, sortDirection }, colName, disableSort) => {
        return (
            <div>
                {_.isFunction(colName) ? colName() : colName}
                {!disableSort && <i className={`icon icon-alan-sort-${sortDirection === SortDirection.DESC ? 'descending' : 'ascending'}`} />}
            </div>
        );
    }

    _sort = ({ sortBy, sortDirection }) => {
        const sortedList = this._sortList({ sortBy, sortDirection });

        this.setState({ sortBy, sortDirection, sortedList });
    }


    _sortList = ({ sortBy, sortDirection }) => {
        const { data } = this.props;
        const sortedData = _.sortBy(data, sortBy);

        if (sortDirection === SortDirection.DESC) {
            return sortedData.reverse();
        }
        return sortedData;
    }

    render() {
        const {
            columns,
            onRowClick,
            headerClassName,
            getRowClassName,
            width
        } = this.props;

        const {
            sortBy,
            sortDirection,
            sortedList
        } = this.state;

        const rowGetter = ({ index }) => sortedList[index];

        return (
            <AutoSizer>
                {({ height }) => (
                    <Table
                        ref="Table"
                        headerHeight={24}
                        noRowsRenderer={this._noRowsRenderer}
                        overscanRowCount={4}
                        rowHeight={24}
                        rowGetter={rowGetter}
                        rowCount={sortedList.length}
                        sort={this._sort}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        width={width}
                        height={height}
                        className={this.props.className}
                        headerClassName={headerClassName}
                        rowClassName={({ index }) => {
                            const className = getRowClassName ? getRowClassName(sortedList[index]) : '';
                            return `${className} ${index % 2 ? 'even' : 'odd'}`;
                        }}
                        onRowClick={onRowClick}>
                        {columns.map(({
                            dataKey,
                            colName,
                            disableSort,
                            width,
                            className,
                            headerClassName,
                            formatter,
                            flexGrow
                        }) => {
                            return <Column
                                key={dataKey}
                                dataKey={dataKey}
                                disableSort={disableSort}
                                headerRenderer={(params,) => {
                                    return this._headerRenderer(params, colName, disableSort);
                                }}
                                width={width}
                                minWidth={width}
                                maxWidth={width}
                                flexGrow={flexGrow}
                                cellRenderer={({ cellData, rowData }) => {
                                    if (formatter) {
                                        return formatter(rowData);
                                    }
                                    return cellData;
                                }}
                                className={className}
                                headerClassName={headerClassName}
                            />;
                        })}
                    </Table>
                )}
            </AutoSizer>
        );
    }
}

export default VirtualizedTable;